import React from "react";

export const SkeletonOne = () => {
  const bars = [3, 6, 4, 8, 5, 7, 3, 9, 6, 4, 8, 5, 7, 3, 6, 9, 5];

  return (
    <div className="relative flex py-8 px-2 gap-10 h-full">
      <div className="w-full p-5 mx-auto bg-neutral-950 shadow-2xl group rounded-2xl border border-neutral-800">
        {/* Status */}
        <div className="flex items-center gap-2 mb-4">
          <div className="w-2 h-2 rounded-full bg-green-500" />
          <span className="text-[10px] text-green-400 font-semibold uppercase tracking-widest">
            In Call
          </span>
        </div>

        {/* Contact */}
        <div className="mb-4">
          <p className="text-white font-semibold text-sm">Marcus Weber</p>
          <p className="text-neutral-500 text-xs">
            Growth Director · Acme Corp
          </p>
        </div>

        {/* Timer */}
        <div className="text-3xl font-mono text-white font-medium mb-4">
          02:34
        </div>

        {/* Waveform */}
        <div className="flex items-center gap-[2px] h-10 mb-5">
          {bars.map((h, i) => (
            <div
              key={i}
              className="w-1.5 rounded-full bg-blue-500"
              style={{
                height: `${h * 3.5}px`,
                opacity: 0.6 + (i % 3) * 0.15,
              }}
            />
          ))}
        </div>

        {/* Action buttons */}
        <div className="flex gap-2">
          <div className="flex-1 h-8 rounded-lg bg-neutral-800 flex items-center justify-center">
            <span className="text-[10px] text-neutral-400">Mute</span>
          </div>
          <div className="flex-1 h-8 rounded-lg bg-red-600 flex items-center justify-center">
            <span className="text-[10px] text-white font-medium">Hang Up</span>
          </div>
          <div className="flex-1 h-8 rounded-lg bg-neutral-800 flex items-center justify-center">
            <span className="text-[10px] text-neutral-400">Record</span>
          </div>
        </div>

        {/* Script hint */}
        <div className="mt-4 pt-4 border-t border-neutral-800">
          <p className="text-[10px] text-neutral-600 mb-2 uppercase tracking-wide">
            Phone Script
          </p>
          <div className="space-y-1.5">
            <div className="h-2 bg-neutral-800 rounded-full w-full" />
            <div className="h-2 bg-neutral-800 rounded-full w-3/4" />
            <div className="h-2 bg-neutral-800 rounded-full w-5/6" />
          </div>
        </div>
      </div>
    </div>
  );
};
